// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"bb46a2f4","143":"6491f2cc","444":"f1b5c80c","541":"6fd51da8","911":"bb33a593"}[chunkId] + ".chunk.css";
};